import { Typography } from '@mui/material';

import { SearchDateRangePicker } from '../../components/SearchDateRangePicker/SearchDateRangePicker.tsx';
import { DateRangeProvider } from '~/components/DateRangeProvider';

interface SearchDateRangeProps {
  title: string;
  attribute: string;
}

export const SearchDateRange = ({ title, attribute }: SearchDateRangeProps) => {
  return (
    <div>
      <Typography variant="subtitle2">{title}</Typography>
      <DateRangeProvider initialDateRangeDefault={[null, null]}>
        <SearchDateRangePicker attribute={attribute} />
      </DateRangeProvider>
    </div>
  );
};
